module.exports = __webpack_public_path__ + "img/slide1-min.8e2fb197.png";